module.exports = __webpack_public_path__ + "static/media/san-diego.05c6df2d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/geojson/san-diego.json
// module id = 948
// module chunks = 27